import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf82847a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "注 册", -1))

import { reactive, Ref, ref, onMounted, onUnmounted, onBeforeUnmount, computed } from 'vue'
  import type { FormInstance } from 'element-plus'
  import api from '@/api/index'
  import { apiStore } from '@/store/api'
  import { getRandomNumber } from '@/util/util'
  import { ElMessage, ElLoading } from 'element-plus'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'register',
  emits: ['change'],
  setup(__props, { emit }) {

  const store = apiStore()

  const ruleFormRef = ref<FormInstance>()
  const codeImg = ref(null) // 图片验证码
  const formRef = ref<FormInstance>() // 表单ref
  const msgCodeVal = ref<String>('') // 短信验证码

  // 密码验证
  const validatePassword = (rule: any, value: any, callback: any) => {
    if (value.length < 6 || value.length > 20) {
      callback(new Error('请输入6~20密码'))
    } else {
      if (ruleForm.checkPassword !== '') {
        if (!ruleFormRef.value) {
          callback()
          return
        }
        ruleFormRef.value.validateField('checkPassword', () => null)
      }
      callback()
    }
  }

  // 两次密码是否一致验证
  const validateCheckPassword = (rule: any, value: any, callback: any) => {
    if (value == '') {
      callback(new Error('请再次输入密码'))
    } else if (value != ruleForm.password) {
      callback(new Error('两次密码输入不一致'))
    } else {
      callback()
    }
  }

  // 用户名验证
  const validateUsername = (rule: any, value: any, callback: any) => {
    const reg = /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{6,20}$/
    if (!reg.test(value)) {
      callback(new Error('用户名格式为6~20位字母数字'))
    } else {
      callback()
    }
  }

  // 手机号验证
  const validatePhone = (rule: any, value: any, callback: any) => {
    const reg = /^[1][3,4,5,7,8][0-9]{9}$/
    if (!reg.test(value)) {
      callback(new Error('手机号码格式错误'))
    } else {
      callback()
    }
  }

  // 注册表单
  const ruleForm = reactive({
    username: '',
    password: '',
    phone: '',
    checkPassword: '',
    captcha: '',
    requestCode: '',
    msgCode: '',
  })

  // 表单校验规则
  const rules = reactive({
    captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
    username: [{ validator: validateUsername, trigger: 'blur' }],
    password: [{ validator: validatePassword, trigger: 'blur' }],
    checkPassword: [{ validator: validateCheckPassword, trigger: 'blur' }],
    phone: [{ validator: validatePhone, trigger: 'blur' }],
    msgCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }],
  })

  

  // 监听登录
  const handleRegister = () => {
    emit('change', 'login')
  }

  // 获取短信按钮
  const buttonTxt = ref('获取验证码')

  // 点击注册
  const register = async () => {
    // 表单必填项校验
    const validate = await new Promise(resolve => {
      formRef.value.validate(val => resolve(val))
    })
    if (!validate) return
    if (ruleForm.msgCode != msgCodeVal.value) {
      ElMessage.error('短信验证码输入错误')
      return
    }
    const res = await api.register(ruleForm)
    emit('change', 'login')
  }

  // 获取验证码
  const getCaptcha = async () => {
    const requestCode = Date.now()
    ruleForm.requestCode = requestCode.toString()
    const res = await api.captcha({ requestCode })
    codeImg.value = res
  }

  // 获取短信倒计时
  let timer = null
  const time = () => {
    buttonTxt.value = store.msgSecond + 's后获取'
    if (store.msgSecond > 1) {
      store.msgSecond--
    } else {
      store.msgSecond = 120
      buttonTxt.value = '获取验证码'
      return
    }
    timer = setTimeout(() => {
      time()
    }, 1000)
  }

  // 发送短信验证码
  const handleSendMsg = async () => {
    // 表单验证
    const validate = await Promise.all([
      new Promise(resolve => {
        formRef.value.validateField('phone', val => resolve(val))
      }),
      new Promise(resolve => {
        formRef.value.validateField('captcha', val => resolve(val))
      }),
    ])

    if (validate.includes(false)) return
    // buttonTxt.value = '发送中'
    time()
    // 发送验证码
    msgCodeVal.value = getRandomNumber()
    api
      .sendMsg({
        requestCode: ruleForm.requestCode,
        phone: ruleForm.phone,
        captcha: ruleForm.captcha,
        signName: '雨顺信息技术三奇数据',
        templateCode: 'SMS_463875118',
        templateParam: { code: msgCodeVal.value },
      })
      .then(() => {})
      .catch(err => {
        clearTimer()
        store.msgSecond = 120
        buttonTxt.value = '获取验证码'
      })
  }

  onMounted(() => {
    // store.msgSecond = 120
    // 阻止用户关闭弹窗或刷新页面可以不用等待即可重复发送验证码
    // if (store.msgSecond < 120) {
    //   time()
    // }
    getCaptcha()
  })
  // 销毁定时器
  const clearTimer = () => {
    clearTimeout(timer)
    timer = null
  }

  onBeforeUnmount(() => {
    clearTimer()
  })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      model: ruleForm,
      "status-icon": "",
      rules: rules,
      "label-width": "0px",
      class: "demo-ruleForm"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "username"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.username) = $event)),
              type: "text",
              placeholder: "用户名（6~20位字母数字）",
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "password"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.password) = $event)),
              type: "password",
              placeholder: "请输入6~20位密码",
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "checkPassword"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.checkPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.checkPassword) = $event)),
              type: "password",
              placeholder: "请再次输入密码",
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "phone"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.phone,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.phone) = $event)),
              type: "text",
              placeholder: "请输入11位手机号",
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "captcha",
          style: {"display":"flex"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.captcha,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.captcha) = $event)),
              placeholder: "请输入验证码",
              style: {"flex":"1"},
              clearable: ""
            }, null, 8, ["modelValue"]),
            _withDirectives(_createElementVNode("span", {
              class: "code-img",
              onClick: getCaptcha
            }, null, 512), [
              [_directive_dompurify_html, codeImg.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "msgCode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.msgCode,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ruleForm.msgCode) = $event)),
              placeholder: "请输入短信验证码",
              clearable: ""
            }, {
              append: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: handleSendMsg,
                  disabled: buttonTxt.value != '获取验证码',
                  loading: buttonTxt.value == '发送中'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(buttonTxt.value), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_el_button, {
      type: "primary",
      class: "login-btn",
      onClick: register
    }, {
      default: _withCtx(() => [
        _createTextVNode("注 册")
      ]),
      _: 1
    }),
    _createElementVNode("div", { class: "reg" }, [
      _createTextVNode("已有账号?"),
      _createElementVNode("span", { onClick: handleRegister }, "立即登录")
    ])
  ], 64))
}
}

})